module.exports = __webpack_public_path__ + "static/media/signal-alt-1.f169f9c0.svg";